import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  creditosAdicionais: {}
});

function creditosadicionaisReducer(state = initialState, action) {
  switch (action.type) {
    case types.CREDITOS_ADICIONAIS_START: {
      return startLoad(state);
    }

    case types.CREDITOS_ADICIONAIS_ERROR: {
      return endLoad(state);
    }

    case types.CREDITOS_ADICIONAIS_SUCCESS: {
      return endLoad(state.set('creditosAdicionais', fromJS(action.payload)));
    }
  }

  return state;
}

export default creditosadicionaisReducer;
